// marketProvider.ts
'use client';
import { createContext, useContext, useState } from 'react';

import { MarketProps } from '@/pages/_app';

const MarketContext = createContext<MarketProps | null>(null);

const MarketProvider = ({
  children,
  market,
}: {
  children: React.ReactNode;
  market: MarketProps;
}) => {
  const [marketContext] = useState(market);

  return <MarketContext.Provider value={marketContext}>{children}</MarketContext.Provider>;
};

const useMarket = () => {
  const marketContext = useContext(MarketContext);
  if (!marketContext) {
    throw new Error('useMarket must be used within a MarketProvider');
  }
  return marketContext;
};

export { MarketProvider, useMarket };
